module.exports = __webpack_public_path__ + "img/mc07.8fc2ed00.jpg";